import { render, staticRenderFns } from "./AddCoach.vue?vue&type=template&id=42da48f9"
import script from "./AddCoach.vue?vue&type=script&lang=js"
export * from "./AddCoach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports